
export enum TypeCards {
    CardConsulta = 'CC',
    CardExame = 'CE'
}